﻿import React from 'react';
import { Tooltip } from "components/tooltip";
import { Table } from 'components/listing';
import { Icon } from '@blueprintjs/core';
import { FormTimePicker, FormSwitch } from 'components/form-fields';
import PropTypes from 'prop-types';
import { HelperFunctions } from 'helpers';
import { Button } from 'components/buttons';
import { ShowHide } from "components/layout";

export function BusinessAreaOperatingHoursTable(
    {
        saving = false,
        readOnly = false,
        loading,
        onClosedAllDay,
        onCopySettings,
        onEndTimeChange,
        onOpenAllDay,
        onStartTimeChange,
        operatingHours
    }
) {

    function formatParamTableHeaders() {

        let paramHeaders = ["", "Day", "Open 24 hours", "Closed All Day", "Open", "Closed", "Open ", "Closed "];

        return {
            headers: paramHeaders.map((value) => {
                return {
                    key: value,
                    value: value
                }
            })
        };
    }

    function onOpenAllDayValue(dayOfWeek, item) {
        HelperFunctions.executeIfNotNull(onOpenAllDay, dayOfWeek, item)
    }

    function onClosedAllDayValue(dayOfWeek, item) {
        HelperFunctions.executeIfNotNull(onClosedAllDay, dayOfWeek, item)
    }

    function onStartTimeChangeValue(dayOfWeek, idx, item) {
        HelperFunctions.executeIfNotNull(onStartTimeChange, dayOfWeek, idx, item)
    }

    function onEndTimeChangeValue(dayOfWeek, idx, item) {
        HelperFunctions.executeIfNotNull(onEndTimeChange, dayOfWeek, idx, item)
    }

    function onCopysettings(dayOfWeek) {
        HelperFunctions.executeIfNotNull(onCopySettings, dayOfWeek)
    }

    function formatParamTable(operatingHoursValue) {
        return operatingHoursValue.map(function (operatingHour) {
            return {
                cells: [
                    <Tooltip content={operatingHour.errorMessage} key={`toolTip${operatingHour.dayOfWeek}`}>
                        <Icon
                            icon={operatingHour.valid ? 'tick' : 'issue'}
                            className={operatingHour.valid ? '' : 'bp6-intent-danger'}
                        />
                    </Tooltip>,
                    operatingHour.day,
                    <FormSwitch
                        id={`select-all-day-${operatingHour.dayOfWeek}`}
                        disabled={loading || saving || operatingHour.closedAllDay || readOnly}
                        checked={operatingHour.openAllDay}
                        onChange={(item) => { onOpenAllDayValue(operatingHour.dayOfWeek, item) }}
                        showLabels
                        key={`openAllDay2${operatingHour.dayOfWeek}`}
                    />,
                    <FormSwitch
                        id={`select-closed-all-day-${operatingHour.dayOfWeek}`}
                        disabled={loading || saving || operatingHour.openAllDay || readOnly}
                        checked={operatingHour.closedAllDay}
                        onChange={(item) => { onClosedAllDayValue(operatingHour.dayOfWeek, item) }}
                        showLabels
                        key={`closedAllDay${operatingHour.dayOfWeek}`}
                    />,
                    <FormTimePicker
                        id={`select-start-time-1-${operatingHour.dayOfWeek}`}
                        disabled={loading || saving || operatingHour.openAllDay || operatingHour.closedAllDay || readOnly}
                        value={operatingHour.startDate}
                        onChange={(item) => { onStartTimeChangeValue(operatingHour.dayOfWeek, 0, item) }}
                        key={`start1${operatingHour.dayOfWeek}`}
                    ></FormTimePicker>,
                    <FormTimePicker
                        id={`select-end-time-1-${operatingHour.dayOfWeek}`}
                        disabled={loading || saving || operatingHour.openAllDay || operatingHour.closedAllDay || readOnly}
                        value={operatingHour.endDate}
                        onChange={(item) => { onEndTimeChangeValue(operatingHour.dayOfWeek, 0, item) }}
                        key={`end1${operatingHour.dayOfWeek}`}
                    ></FormTimePicker>,
                    <FormTimePicker
                        id={`select-start-time-2-${operatingHour.dayOfWeek}`}
                        disabled={loading || saving || operatingHour.range2Disabled || operatingHour.openAllDay || operatingHour.closedAllDay || readOnly}
                        value={operatingHour.startDate1}
                        onChange={(item) => { onStartTimeChangeValue(operatingHour.dayOfWeek, 1, item) }}
                        key={`start2${operatingHour.dayOfWeek}`}
                    ></FormTimePicker>,
                    <FormTimePicker
                        id={`select-end-time-2-${operatingHour.dayOfWeek}`}
                        disabled={loading || saving || operatingHour.range2Disabled || operatingHour.openAllDay || operatingHour.closedAllDay || readOnly}
                        value={operatingHour.endDate1}
                        onChange={(item) => { onEndTimeChangeValue(operatingHour.dayOfWeek, 1, item) }}
                        key={`end2${operatingHour.dayOfWeek}`}
                    ></FormTimePicker>,
                    <ShowHide
                        evaluator={operatingHour.valid && operatingHour.dayOfWeek !== 0}
                        key={`showHideCopy${operatingHour.dayOfWeek}`}
                        show={(
                            <Tooltip content="Copy to the row below" key={`copyToolTip${operatingHour.dayOfWeek}`}>
                                <Button onClick={() => onCopysettings(operatingHour.dayOfWeek)} icon="duplicate" iconOnly={true} text="Copy to the row below" large={false} minimal={true} key={`copyIcon${operatingHour.dayOfWeek}`}></Button>                            
                            </Tooltip>
                        
                    )}
                />
                    
                ],
                key: operatingHour.dayOfWeek
            };
        });
    }

    return (
        <Table
        headerData={formatParamTableHeaders()}
            data={formatParamTable(operatingHours)}
            loadingData={false}
            fitToContent={false}
        />
    );
}

BusinessAreaOperatingHoursTable.propTypes = {
    operatingHours: PropTypes.array.isRequired,
    saving: PropTypes.bool,
    loading: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool
};